export default "__VITE_PUBLIC_ASSET__9daba27b__"